import React from 'react'

import cx from 'classnames'
import { Route, Switch } from 'react-router-dom'

import { P } from '@driftt/tide-core'

import { Flow } from 'constants/flowConstants'
import SignupCard from 'layouts/SignupCard'
import TrackWebstoreReferrer from 'layouts/TrackWebstoreReferrer'
import VideoExtensionLoginRedirect from 'layouts/VideoExtensionLoginRedirect'
import VideoInstallStep from 'layouts/VideoInstallStep'
import VideoLandingStep from 'layouts/VideoLandingStep'
import VideoProcessThirdPartySignup from 'layouts/VideoProcessThirdPartySignup'
import VideoSuccessStep from 'layouts/VideoSuccessStep'
import VideoSurveyStep from 'layouts/VideoSurveyStep'
import VideoThirdPartyLandingStep from 'layouts/VideoThirdPartyLandingStep'
import { getVideoSignupReferrer, track } from 'utils/trackingUtils'

import driftIconLarge from '../../images/drift-icon-large.svg'
import driftVideoSrc from '../../images/drift-video-logo-new.png'
import helloText from '../../images/greeting.png'
import welcomeVideoSrc from '../../images/welcome-video.mp4'
import welcomeVideoThumbnail from '../../images/welcome-video-thumbnail.png'
import yellowArrow from '../../images/yellow-arrow.png'

import graffitiTextureDesktop from './graffiti-texture-desktop.svg'
import graffitiTextureDesktop2 from './graffiti-texture-desktop-2.svg'

import './style.css'

const clickedVideoEvent = () =>
  track('Video Signup Page Content Clicked', {
    content: 'welcome_video',
    page: window.location.pathname,
  })

const controlVersionContent = (
  <div className="welcome-video-container">
    <video
      className="welcome-video"
      controls
      preload="none"
      poster={welcomeVideoThumbnail}
      onClick={clickedVideoEvent}
    >
      <source src={welcomeVideoSrc} type="video/mp4" />
    </video>
    <img className="greeting" src={helloText} alt="Hello!" />
    <img className="yellow-arrow" src={yellowArrow} alt="" />
    <P>From part of the team that built Drift Video</P>
  </div>
)

const getSplitPaneEducationContent = () => {
  return controlVersionContent
}

const VideoController = ({ loginUrl }) => {
  const showSplitPaneLayout = window.location.pathname.includes('/video/start')

  const accessType = getVideoSignupReferrer() || ''
  let installVariant = 'marketing'

  if (
    accessType.includes('drift.com/powered') ||
    accessType.includes('video_cta')
  ) {
    installVariant = 'powered-by'
  } else if (accessType === 'app-switcher' || accessType === 'nav_icon') {
    installVariant = 'app-switcher'
  }

  return (
    <div
      className={cx('video-setup-container', `${installVariant}-variant`, {
        'video-split-pane-layout': showSplitPaneLayout,
      })}
    >
      <img
        className="video-setup-background-left"
        src={graffitiTextureDesktop}
        alt=""
      />
      <img
        className="video-setup-background-right"
        src={graffitiTextureDesktop2}
        alt=""
      />
      {!showSplitPaneLayout && (
        <div className="video-logo-container">
          <img
            className="video-logo-image"
            src={driftVideoSrc}
            alt="Drift Video"
          />
        </div>
      )}
      <div className="video-setup-content">
        <Switch>
          <Route
            exact
            path="/video/start"
            render={() => <SignupCard flow={Flow.VIDEO} loginUrl={loginUrl} />}
          />
          <Route
            exact
            path="/video/select/google"
            component={VideoProcessThirdPartySignup}
          />
          <Route
            exact
            path="/video/select/microsoft"
            component={VideoProcessThirdPartySignup}
          />
          <Route exact path="/video/success" component={VideoSuccessStep} />
          <Route
            exact
            path="/video/extension"
            render={() => <VideoInstallStep installVariant={installVariant} />}
          />
          <Route exact path="/video/landing" component={VideoLandingStep} />
          <Route
            exact
            path="/video/landing/oauth"
            component={VideoThirdPartyLandingStep}
          />
          <Route
            exact
            path="/video/track-webstore-referrer"
            component={TrackWebstoreReferrer}
          />
          <Route
            exact
            path="/video/extension-login"
            component={VideoExtensionLoginRedirect}
          />
          <Route exact path="/video/survey" component={VideoSurveyStep} />
          <Route
            path="/"
            render={() => <SignupCard flow={Flow.VIDEO} loginUrl={loginUrl} />}
          />
        </Switch>
      </div>
      {showSplitPaneLayout && (
        <div className="video-split-pane-layout-content">
          <div className="video-split-pane-video-container">
            {getSplitPaneEducationContent()}
          </div>
          <img className="large-drift-icon-bg" src={driftIconLarge} alt="" />
        </div>
      )}
    </div>
  )
}

export default VideoController
